import React, { useState } from 'react';
import Cookies from "universal-cookie";

import Agent from "../../../Network/Agent";
import {BASE_URL, KEY_TOKEN, preUrl, projectUrl} from "../../../Config/SharedConfig";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import LoginAlert from "../../../Components/EmptyState/LoginAlert";
import PanelRow from "../../../Components/Store/ui/PanelRow";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";
import {getStoreName} from "../../../Components/Utils/getStoreName";

const Profile = () => {
    const storeUsernameInUrl = getStoreName()

    const [activeModal, setActiveModal] = useState(null)
    const [firstName, setFirstName] = useState(null)
    const [firstNameError, setFirstNameError] = useState(null)
    const [lastName, setLastName] = useState(null)
    const [lastNameError, setLastNameError] = useState(null)

    const queryClient = useQueryClient()

    const {data: user, isLoading: isLoadingUser, isError : isErrorUser} = useQuery({
        queryKey : ['userInfo', storeUsernameInUrl],
        queryFn : async () => {
            const response = await Agent.User.get()
            const {user} = response.data.result
            setFirstName(user.firstName)
            setLastName(user.lastName)
            return user
        }
    })

    const {mutate : mutateUser, isPending: isSubmittingUserFullName} = useMutation({
        mutationFn: async () => {
            return Agent.User.updateName(firstName, lastName);
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: ['userInfo', storeUsernameInUrl],
                exact: true
            })
            setActiveModal(null)
        },
        onError: (error) => {
            const errors = error.response.data.errors
            const firstNameError = errors.find((item) => item.property === "firstName")
            const lastNameError = errors.find((item) => item.property === "lastName")
            setFirstNameError(firstNameError?.message || '')
            setLastNameError(lastNameError?.message || '')
        },
    });

    const handleSubmitUserFullName = (e) => {
        e.preventDefault()
        mutateUser()
    }

    const {mutate: logout, isPending: isLoggingOut, isError: isErrorLogout} = useMutation({
        mutationFn: async () => {
            return Agent.User.logout()
        },
        onSettled: (res) => {
            sessionStorage.clear();
            localStorage.clear();
            const cookies = new Cookies();
            cookies.remove(KEY_TOKEN);
            cookies.remove(KEY_TOKEN, { path: '/' });
            cookies.remove(KEY_TOKEN, {
                path: '/',
                domain: `.${projectUrl}`,
            });
            cookies.remove(KEY_TOKEN, {
                path: '/',
                domain: `${projectUrl}`,
            });
            window.location = preUrl+projectUrl;
        }
    })

    if (isLoadingUser) {
        return (
            <div className='shimmer-container'>
                <div className='container'>
                    <div className='row justify-content-center mt-64'>
                        <div className='col-auto'>
                            <div className='avatar-cnt-100 shimmer'/>
                        </div>
                    </div>
                    <div className='row justify-content-center mt-24'>
                        <div className='col-6'>
                            <div className='line-100 shimmer'/>
                        </div>
                    </div>
                    <div className='row mt-56'>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-16'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row g-3 mt-24'>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-8'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-8'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (isErrorUser) {
        return <LoginAlert/>;
    }
    return (
        <>
            {/* avatar phone name */}
            <div className='container mt-64'>
                <div className="row justify-content-center">
                    <div className='col-auto'>
                        <form action="" encType='multipart/form-data'>
                            <div className='form-group-avatar'>
                                <label className="form-group-label">
                                    <input disabled={true} type="file" className='form-group-input'/>
                                    <div className='label-view'>
                                        <div className="img-cnt">
                                            <img src={BASE_URL + user.avatar} alt='avatar'/>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-auto">
                        <div className='mobile-h3 cl-black mt-20'>
                            {user.phoneNumber}
                        </div>
                    </div>
                </div>
                <div className='row mt-32'>
                    <div className='col-12'>
                        <PanelRow
                            hasDivider={false}
                            activeModal={activeModal}
                            setActiveModal={setActiveModal}
                            modalKey='userInfo'
                            title={`${user.firstName} ${user.lastName}`}
                            label='نام و نام خانوادگی'
                            operationTitle='ویرایش'
                        >
                            <div className='d-flex justify-content-center pt-10 pb-10'
                                 onClick={() => setActiveModal(null)}>
                                <div className='bottom-sheet-close-line btn p-0 '/>
                            </div>
                            <div className='mobile-h5 cl-black mt-20'>
                                تغییر نام
                            </div>
                            <form id='form_send_name' onSubmit={handleSubmitUserFullName}>
                                <div className='form-group-input-primary mt-32'>
                                    <label className="form-group-label">
                                        <input type="text"
                                               className={`form-group-input ${firstNameError ? 'hasError' : ''}`}
                                               defaultValue={user.firstName}
                                               onChange={(e) => setFirstName(e.target.value)}
                                               placeholder='مثال : بهنام ...'/>
                                    </label>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {firstNameError}
                                    </div>
                                </div>


                                <div className='form-group-input-primary mt-16'>
                                    <label className="form-group-label">
                                        <input type="text"
                                               className={`form-group-input ${lastNameError ? 'hasError' : ''}`}
                                               defaultValue={user.lastName}
                                               onChange={(e) => setLastName(e.target.value)}
                                               placeholder='مثال : حسن نیا ...'/>
                                    </label>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {lastNameError}
                                    </div>

                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary mode='dark-mode' text='ثبت' isLoading={isSubmittingUserFullName}/>
                                </div>
                            </form>
                        </PanelRow>
                    </div>
                </div>
            </div>
            <div className='divider-12px bg-gray-custom-1 mt-12'/>
            {/* subscription logout */}
            <div className='container'>
                <div className='row'>
                    {/* subscription */}
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between mt-12'>
                            <div className='d-flex align-items-center'>
                                <div className='img-cnt-24'>
                                    <img src={"/assets/images/vectors/premium_user_line_black.svg"} alt='user'/>
                                </div>
                                <div className='mobile-subtitle-strong cl-black mr-20'>
                                    عضویت
                                </div>
                            </div>
                            <div>
                                <div className='mobile-body-2-strong cl-subtitle'>
                                    {user.subscription.title}
                                </div>
                            </div>
                        </div>
                        <div className='divider-1px bg-gray-custom-1 mt-12'/>
                    </div>
                    <div className='col-12'>
                        <PanelRow
                            title='خروج از حساب کاربری'
                            titleColorClass='cl-tomato'
                            rightIcon={<img src={"/assets/images/vectors/logout_line_red.svg"} alt='logout'/>}
                            operationTitle=''
                            activeModal={activeModal}
                            setActiveModal={setActiveModal}
                            modalKey='logout'
                        >
                            <div className='mobile-h5 cl-black mt-20'>
                                خروج
                            </div>
                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                آیا می خواهید از حساب کاربری خود خارج شوید ؟
                            </div>

                            <div className='row align-items-center mt-32'>
                                <div className='col-6'>
                                    <div onClick={() => setActiveModal(null)}>
                                        <ButtonPrimary text='انصراف'
                                                       mode='light-mode'/>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div onClick={logout}>
                                        <ButtonPrimary text='خروج'
                                                       mode='dark-mode'
                                                       isLoading={isLoggingOut}/>
                                    </div>
                                </div>
                            </div>

                        </PanelRow>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Profile;
